import { Grid, Stack, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import { StyledCommentGrid } from "./TabsContent.styles";
import { CardShareTabs, CommunityClusterSelect } from "../../components";
import { TitleAndSubtitle } from "../../components/Commons/TitleAndSubtitle.component";
import type { SharedPost } from "../../queries/community.types";
// import { TabDigited } from "../Commons/TabDigited.component";

export function TabsContentCommunity({
  loId,
  sharedPosts,
  title
} : {
  loId: string,
  title?: string,
  sharedPosts?: SharedPost
}
) {
  const { t } = useTranslation();
 
  const thereAreSharedPost =()=> sharedPosts?.data && sharedPosts?.data.length > 0; 

  return (
    <Stack 
      flexDirection={ "column" }
      gap={ "1rem" }
    >
      <TitleAndSubtitle
        title={ title }
      />
      <Stack 
        flexDirection={ "column" }
        gap={ "1rem" }
      >
        { /* TODO DA CREARE FILTRI TAB*/ }
        { /* <TabDigited 
          ariaLabel="fitler tabs explore detail page"
          tabs={ [] } 
          onClickTab={ (tab) => {
            console.log("click tab", tab);          
          } }
          scope="shareOpinions"
        >  */ }

        <StyledCommentGrid>
          <CommunityClusterSelect 
            predicate={ (cluster) => cluster.is_share_enabled } 
          />
          {
            thereAreSharedPost() 
              ? sharedPosts?.data.map((sharedPost) => {
                const ownerUserId = sharedPost.owner_id;
                const ownerUser = sharedPosts.enrichedInformation?.users?.find(user => user.owner_id === ownerUserId);
                return (
                  <CardShareTabs
                    postId={ sharedPost.id }
                    topicOwner={ ownerUserId }
                    key={ `comment--${sharedPost.id}` }
                    body={ sharedPost.body }
                    created={ sharedPost.created }
                    loId={ loId }
                    ownerName={ `${ownerUser?.name} ${ownerUser?.surname}` || "" }
                    ownerImage={ ownerUser?.profileImageUrl }
                  />
                );
              }) 
              : (
                <Grid
                  alignItems={ "center" }
                  display={ "flex" }
                  flexDirection={ "column" }
                  justifyContent={ "center" }
                  gap={ 2 }

                >
                  <Typography
                    tabIndex={ 0 }
                    padding={ "42px 80px" }
                    textAlign={ "center" }
                  >
                    { t("no_shared_posts_available") }
                  </Typography>
                </Grid>
              )
          }
        </StyledCommentGrid>
        { /* </TabDigited>  */ }
      </Stack>
    </Stack>
  );
}
